<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>169 - Международные</h3>

      <div class="filters">
        <div>
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9" v-if="isAdmin() || isManagerFC()">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">

      <a @click="openCreateDialog" class="btn btn-success" v-if="isUniversityManager()">
        Добавить
      </a>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(trancheYear)="data">
        <div class="sortable-container none"
             @click="onSortChanged('trancheYear')"
             :class="{'ascending': page.sort.trancheYear === 'ASC', 'descending': page.sort.trancheYear === 'DESC'}">
          Год
        </div>
      </template>
      <template #head(avgCost)="data">
        <div class="sortable-container none"
             @click="onSortChanged('avgCost')"
             :class="{'ascending': page.sort.avgCost === 'ASC', 'descending': page.sort.avgCost === 'DESC'}">
          Общая стоимость
        </div>
      </template>
      <template #head(totalSum)="data">
        <div class="sortable-container none"
             @click="onSortChanged('totalSum')"
             :class="{'ascending': page.sort.totalSum === 'ASC', 'descending': page.sort.totalSum === 'DESC'}">
          ВСЕГО
        </div>
      </template>
      <template #head(actions)="data">
      </template>

      <template #cell(universityName)="data">
        <a :href="`/expenses/international/${data.item.uuid}`">
          {{ data.item.universityName }}
        </a>
      </template>

      <template #cell(trancheYear)="data">{{ data.item.trancheYear }}</template>
      <template #cell(avgCost)="data">{{ data.item.avgCost }}</template>
      <template #cell(totalSum)="data">{{ data.item.totalSum }}</template>
      <template #cell(actions)="data">
        <div class="action-cell" v-if="canRemove(data.item)">

          <el-button type="text" class="btn-icon btn-excel"
                     @click="onClickGenerateAndXls(data.item)">
            <font-awesome-icon :icon="['fas', 'file-excel']"/>
          </el-button>

          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>
  <b-modal id="create-modal" title="Создать запись" v-model="dialogVisible" @ok="handleCreate" ok-title="Создать" cancel-title="Отмена" :ok-disabled="creating">
    <b-form-group label="Год" label-for="year-select">
      <b-form-select v-model="selectedYear" :options="trancheYears" id="year-select"></b-form-select>
    </b-form-group>
  </b-modal>
  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import settingsService from "@/services/settingsService";
import delegationService from "@/services/delegationService";
import {saveAs} from "@/assets/FileSaver.min";
import Multiselect from "vue-multiselect";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import ueExpensesService from "@/services/ueExpensesService";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      creating: false,
      selectedYear: new Date().getFullYear(),
      expenseType: 'international',
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          trancheYear: null,
          universityId: null
        },
        sort: {
          trancheYear: null,
          universityName: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'universityName', label: 'ВУЗ', sortable: true},
        {key: 'trancheYear', label: 'Год', sortable: true},
        {key: 'avgCost', label: 'Общая стоимость', sortable: true},
        {key: 'totalSum', label: 'Всего', sortable: true},
        {key: 'actions', sortable: false}
      ],
      items: [],
      universities: [],
      trancheYears: ueExpensesService.getDefaultYears(),
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.reloadList();
      });
    },
    async reloadList() {
      this.isLoading = true;
      const response = await ueExpensesCommonCrudService.getAll(this.expenseType, this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    async onClickGenerateAndXls(item) {
      this.isLoading = true;
      const response = await ueExpensesCommonCrudService.generateAndGetXls(this.expenseType, item.uuid, this.page);
      const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "expenses_tax_" + item.uuid + ".xlsx");
      this.isLoading = false;
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await ueExpensesCommonCrudService.deleteById(this.expenseType, item.uuid);
          this.reloadList();
          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    canRemove(dto) {
      return dto.status === 'CREATED';
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    openCreateDialog() {
      this.dialogVisible = true;
    },
    async handleCreate(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.creating = true;
      try {
        await ueExpensesCommonCrudService.create(this.expenseType, { trancheYear: this.selectedYear });
        showSuccessNotify('Запись успешно создана');
        this.dialogVisible = false;
        this.reloadList();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          showErrorNotify('Запись для выбранного года уже существует');
        } else {
          showErrorNotify('Ошибка при создании записи');
        }
      } finally {
        this.creating = false;
      }
    },
  },
  mounted() {
    this.initUniversities();
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}
.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
  margin-right: 2px;
}

.btn-excel {
  color: green;
}
</style>
